import { getRequest, postJSONRequest } from '../../utils/requests';
import { handleAPIError } from '../../utils/apiResponeHandler';
import { gt_config } from '../../configs';

export const fetchPendingInvites = async () => {
  try {
    const response = await fetch(
      getRequest(`${gt_config.urls.networking}invites`),
    );
    const res = await handleAPIError(response);
    const json = await res.json();
    return json.data;
  } catch (error) {
    // do nothing
    console.error(error);
  }
  return false;
};

export const invite = async (emails, mobiles, message) => {
  try {
    const response = await fetch(
      postJSONRequest(`${gt_config.urls.networking}invite`),
      { emails, mobiles, message },
    );
    const res = await handleAPIError(response);
    const json = await res.json();
    if (json.status) return true;
    else return json.data;
  } catch (error) {
    // do nothing
    console.error(error);
  }
  return false;
};

export const processInvite = async (token) => {
  try {
    const response = await fetch(
      postJSONRequest(`${gt_config.urls.networking}process_invite`),
      { token },
    );
    const res = await handleAPIError(response);
    const json = await res.json();
    if (json.status) return true;
  } catch (error) {
    // do nothing
    console.error(error);
  }
  return false;
};

export const receiveConnectRequest = async (fromUser) => {
  try {
    const response = await fetch(
      getRequest(`${gt_config.urls.networking}receive_connect/${fromUser}`),
    );
    const res = await handleAPIError(response);
    const json = await res.json();
    if (json.status) return true;
  } catch (error) {
    // do nothing
    console.error(error);
  }
  return false;
};

export const receiveConnectRequests = async (fromUsers) => {
  try {
    const response = await fetch(
      postJSONRequest(`${gt_config.urls.networking}receive_connects`, {
        friends: fromUsers,
      }),
    );
    const res = await handleAPIError(response);
    const json = await res.json();
    if (json.status) return true;
  } catch (error) {
    // do nothing
    console.error(error);
  }
  return false;
};
